"use client";

// Left "In This Article" table of contents.
// Presentational — items + activeId are derived by the parent from the rendered article.
export default function ArticleTOC({ items, activeId }) {
  if (!items?.length) return null;

  const handleClick = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    if (typeof history !== "undefined") {
      history.replaceState(null, "", `#${id}`);
    }
  };

  return (
    <nav aria-label="In this article">
      <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-400 mb-4">
        In This Article
      </p>
      <ul className="border-l border-gray-200 ">
        {items.map((item) => {
          const isActive = item.id === activeId;
          return (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                onClick={(e) => handleClick(e, item.id)}
                aria-current={isActive ? "true" : undefined}
                className={`-ml-px block border-l-2 py-1.5 text-sm leading-snug transition-colors ${
                  item.level === "h3" ? "pl-7" : "pl-4"
                } ${
                  isActive
                    ? "border-[#9573F7] text-[#9573F7] font-medium"
                    : "border-transparent text-gray-500 hover:text-gray-900"
                }`}
              >
                {item.text}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
